import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getAxiosInstance } from "../../apis/index";

const initialState = {
  status: "idle",
  error: null,
  message: null,
  orderDetailsData: null,
};

export const getorderDetails = createAsyncThunk(
  "orderDetails/getorderDetails",
  async (params, { rejectWithValue }) => {
    let data = {
      token: localStorage.getItem("authToken"),
    };
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`order/${params}`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getCancelOrder = createAsyncThunk(
  "orderDetails/getCancelOrder",
  async (params, { rejectWithValue }) => {
    let data = {
      token: localStorage.getItem("authToken"),
    };
    const api = await getAxiosInstance();
    try {
      const response = await api.post(`order-cancel/${params}`, data);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const orderDetailsSlice = createSlice({
  name: "orderDetails",
  initialState,
  reducers: {},
  extraReducers: {
    [getorderDetails.pending]: (state, action) => {
      state.status = "loading";
      state.message = null;
    },
    [getorderDetails.fulfilled]: (state, action) => {
      state.status = "succeeded";
      state.orderDetailsData = action.payload?.data;
      localStorage.setItem("orderID", action.payload?.data?.data?.id);
    },
    [getorderDetails.rejected]: (state, action) => {
      state.status = "failed";
    },
  },
});

export default orderDetailsSlice.reducer;
